var _circle, _circle2, _path, _path2, _line, _circle3, _circle4, _circle5, _circle6, _circle7, _text, _text2, _circle8, _circle9, _circle10, _circle11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaMadhuriLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e40af",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f172a",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fbbf24",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f59e0b",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "url(#bgGradient)",
    stroke: "#fbbf24",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 85,
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 1,
    opacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 70 100 L 70 110 Q 70 115 75 115 L 85 115 Q 90 115 90 110 L 90 100",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 110 100 L 110 110 Q 110 115 105 115 L 95 115 Q 90 115 90 110",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 110,
    y2: 100,
    stroke: "#fbbf24",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 100,
    r: 3,
    fill: "#fbbf24"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 112,
    r: 4,
    fill: "#fbbf24",
    opacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 113,
    r: 3,
    fill: "#fbbf24",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 112,
    r: 4,
    fill: "#fbbf24",
    opacity: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 113,
    r: 3,
    fill: "#fbbf24",
    opacity: 0.6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 145,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#fbbf24",
    textAnchor: "middle",
    letterSpacing: 1
  }, "CA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 165,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#ffffff",
    textAnchor: "middle",
    letterSpacing: 0.5
  }, "MADHURI")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 80,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 80,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 130,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 130,
    r: 2,
    fill: "#fbbf24",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaMadhuriLogo);
export default __webpack_public_path__ + "static/media/CAMadhuri_Logo.78fb3ef4fda169753754f97157604d5a.svg";
export { ForwardRef as ReactComponent };